export default "__VITE_ASSET__DFpH8dHE__"